import type {PropsWithChildren} from "react";

export function FixtureBoundary({source, replacement, children}: PropsWithChildren<{
  source: string;
  replacement: string;
}>) {
  return <section className="fixture-boundary" data-data-origin="DEMONSTRATION">
    <aside className="fixture-warning" role="note">
      <strong>Demonstration data — not live operational state</strong>
      <span>Source: {source}. Live replacement: {replacement}.</span>
    </aside>
    {children}
  </section>;
}
